export const INVOICES_RETRIEVE = "invoices.retrieve";
export const INVOICES_CREATE = "invoices.create";
export const INVOICES_UPDATE = "invoices.update";
export const INVOICES_DESTROY = "invoices.destroy";

export const INVOICES_RETRIEVE_LABEL = "Leer";
export const INVOICES_CREATE_LABEL = "Crear";
export const INVOICES_UPDATE_LABEL = "Editar";
export const INVOICES_DESTROY_LABEL = "Eliminar";

export const CREDIT_NOTES_RETRIEVE = "credit_notes.retrieve";
export const CREDIT_NOTES_CREATE = "credit_notes.create";
export const CREDIT_NOTES_UPDATE = "credit_notes.update";
export const CREDIT_NOTES_DESTROY = "credit_notes.destroy";

export const CREDIT_NOTES_RETRIEVE_LABEL = "Leer";
export const CREDIT_NOTES_CREATE_LABEL = "Crear";
export const CREDIT_NOTES_UPDATE_LABEL = "Editar";
export const CREDIT_NOTES_DESTROY_LABEL = "Eliminar";

export const DEBIT_NOTES_RETRIEVE = "debit_notes.retrieve";
export const DEBIT_NOTES_CREATE = "debit_notes.create";
export const DEBIT_NOTES_UPDATE = "debit_notes.update";
export const DEBIT_NOTES_DESTROY = "debit_notes.destroy";

export const DEBIT_NOTES_RETRIEVE_LABEL = "Leer";
export const DEBIT_NOTES_CREATE_LABEL = "Crear";
export const DEBIT_NOTES_UPDATE_LABEL = "Editar";
export const DEBIT_NOTES_DESTROY_LABEL = "Eliminar";

export const REMISSION_NOTES_RETRIEVE = "remission_notes.retrieve";
export const REMISSION_NOTES_CREATE = "remission_notes.create";
export const REMISSION_NOTES_UPDATE = "remission_notes.update";
export const REMISSION_NOTES_DESTROY = "remission_notes.destroy";

export const REMISSION_NOTES_RETRIEVE_LABEL = "Leer";
export const REMISSION_NOTES_CREATE_LABEL = "Crear";
export const REMISSION_NOTES_UPDATE_LABEL = "Editar";
export const REMISSION_NOTES_DESTROY_LABEL = "Eliminar";

export const AUTO_INVOICES_RETRIEVE = "auto_invoices.retrieve";
export const AUTO_INVOICES_CREATE = "auto_invoices.create";
export const AUTO_INVOICES_UPDATE = "auto_invoices.update";
export const AUTO_INVOICES_DESTROY = "auto_invoices.destroy";

export const AUTO_INVOICES_RETRIEVE_LABEL = "Leer";
export const AUTO_INVOICES_CREATE_LABEL = "Crear";
export const AUTO_INVOICES_UPDATE_LABEL = "Editar";
export const AUTO_INVOICES_DESTROY_LABEL = "Eliminar";

export const RECEIPTS_RETRIEVE = "receipts.retrieve";
export const RECEIPTS_CREATE = "receipts.create";
export const RECEIPTS_UPDATE = "receipts.update";
export const RECEIPTS_DESTROY = "receipts.destroy";

export const RECEIPTS_RETRIEVE_LABEL = "Leer";
export const RECEIPTS_CREATE_LABEL = "Crear";
export const RECEIPTS_UPDATE_LABEL = "Editar";
export const RECEIPTS_DESTROY_LABEL = "Eliminar";

export const DISABLEMENTS_RETRIEVE = "disablements.retrieve";
export const DISABLEMENTS_CREATE = "disablements.create";
export const DISABLEMENTS_UPDATE = "disablements.update";
export const DISABLEMENTS_DESTROY = "disablements.destroy";

export const DISABLEMENTS_RETRIEVE_LABEL = "Leer";
export const DISABLEMENTS_CREATE_LABEL = "Crear";
export const DISABLEMENTS_UPDATE_LABEL = "Editar";
export const DISABLEMENTS_DESTROY_LABEL = "Eliminar";

export const TAX_PAYER_SETTINGS_UPDATE = "tax_payer_settings.update";

export const TAX_PAYER_SETTINGS_UPDATE_LABEL = "Editar";

export const ALL_PERMISSIONS: string[] = [
  // Invoices
  INVOICES_RETRIEVE,
  INVOICES_CREATE,
  INVOICES_UPDATE,
  INVOICES_DESTROY,

  // Credit Notes
  CREDIT_NOTES_RETRIEVE,
  CREDIT_NOTES_CREATE,
  CREDIT_NOTES_UPDATE,
  CREDIT_NOTES_DESTROY,

  // Debit Notes
  DEBIT_NOTES_RETRIEVE,
  DEBIT_NOTES_CREATE,
  DEBIT_NOTES_UPDATE,
  DEBIT_NOTES_DESTROY,

  // Remission Notes
  REMISSION_NOTES_RETRIEVE,
  REMISSION_NOTES_CREATE,
  REMISSION_NOTES_UPDATE,
  REMISSION_NOTES_DESTROY,

  // Auto Invoices
  AUTO_INVOICES_RETRIEVE,
  AUTO_INVOICES_CREATE,
  AUTO_INVOICES_UPDATE,
  AUTO_INVOICES_DESTROY,

  // Receipts
  RECEIPTS_RETRIEVE,
  RECEIPTS_CREATE,
  RECEIPTS_UPDATE,
  RECEIPTS_DESTROY,

  // Disablements
  DISABLEMENTS_RETRIEVE,
  DISABLEMENTS_CREATE,
  DISABLEMENTS_UPDATE,
  DISABLEMENTS_DESTROY,

  // Tax Payer settings
  TAX_PAYER_SETTINGS_UPDATE,
];

export const PERMISSION_GROUPS: Map<
  string,
  { value: string; label: string }[]
> = new Map([
  [
    "Facturas Electrónicas",
    [
      { value: INVOICES_RETRIEVE, label: INVOICES_RETRIEVE_LABEL },
      { value: INVOICES_CREATE, label: INVOICES_CREATE_LABEL },
      { value: INVOICES_UPDATE, label: INVOICES_UPDATE_LABEL },
      { value: INVOICES_DESTROY, label: INVOICES_DESTROY_LABEL },
    ],
  ],
  [
    "Notas de Crédito Electrónicas",
    [
      { value: CREDIT_NOTES_RETRIEVE, label: CREDIT_NOTES_RETRIEVE_LABEL },
      { value: CREDIT_NOTES_CREATE, label: CREDIT_NOTES_CREATE_LABEL },
      { value: CREDIT_NOTES_UPDATE, label: CREDIT_NOTES_UPDATE_LABEL },
      { value: CREDIT_NOTES_DESTROY, label: CREDIT_NOTES_DESTROY_LABEL },
    ],
  ],
  [
    "Notas de Débito Electrónicas",
    [
      { value: DEBIT_NOTES_RETRIEVE, label: DEBIT_NOTES_RETRIEVE_LABEL },
      { value: DEBIT_NOTES_CREATE, label: DEBIT_NOTES_CREATE_LABEL },
      { value: DEBIT_NOTES_UPDATE, label: DEBIT_NOTES_UPDATE_LABEL },
      { value: DEBIT_NOTES_DESTROY, label: DEBIT_NOTES_DESTROY_LABEL },
    ],
  ],
  [
    "Notas de Remisión Electrónicas",
    [
      {
        value: REMISSION_NOTES_RETRIEVE,
        label: REMISSION_NOTES_RETRIEVE_LABEL,
      },
      { value: REMISSION_NOTES_CREATE, label: REMISSION_NOTES_CREATE_LABEL },
      { value: REMISSION_NOTES_UPDATE, label: REMISSION_NOTES_UPDATE_LABEL },
      { value: REMISSION_NOTES_DESTROY, label: REMISSION_NOTES_DESTROY_LABEL },
    ],
  ],
  [
    "Autofacturas Electrónicas",
    [
      {
        value: AUTO_INVOICES_RETRIEVE,
        label: AUTO_INVOICES_RETRIEVE_LABEL,
      },
      { value: AUTO_INVOICES_CREATE, label: AUTO_INVOICES_CREATE_LABEL },
      { value: AUTO_INVOICES_UPDATE, label: AUTO_INVOICES_UPDATE_LABEL },
      { value: AUTO_INVOICES_DESTROY, label: AUTO_INVOICES_DESTROY_LABEL },
    ],
  ],
  [
    "Recibos",
    [
      {
        value: RECEIPTS_RETRIEVE,
        label: RECEIPTS_RETRIEVE_LABEL,
      },
      { value: RECEIPTS_CREATE, label: RECEIPTS_CREATE_LABEL },
      { value: RECEIPTS_UPDATE, label: RECEIPTS_UPDATE_LABEL },
      { value: RECEIPTS_DESTROY, label: RECEIPTS_DESTROY_LABEL },
    ],
  ],
  [
    "Inutilizaciónes",
    [
      {
        value: DISABLEMENTS_RETRIEVE,
        label: DISABLEMENTS_RETRIEVE_LABEL,
      },
      { value: DISABLEMENTS_CREATE, label: DISABLEMENTS_CREATE_LABEL },
      { value: DISABLEMENTS_UPDATE, label: DISABLEMENTS_UPDATE_LABEL },
      { value: DISABLEMENTS_DESTROY, label: DISABLEMENTS_DESTROY_LABEL },
    ],
  ],
  [
    "Contribuyente",
    [
      {
        value: TAX_PAYER_SETTINGS_UPDATE,
        label: TAX_PAYER_SETTINGS_UPDATE_LABEL,
      },
    ],
  ],
]);
